<template>
  <modal :visible.sync='visible' width='400px' :title="$t('public.Transport_Code')">
    <div class='uk-flex uk-flex-center'>
      <img :src='codeSrc' />
    </div>
  </modal>
</template>

<script>
import bus from '@/utils/bus'
import { getTransportCode } from '@/api/modules/transport'

export default {
  data () {
    return {
      visible: false,
      codeSrc: ''
    }
  },
  mounted () {
    bus.$on('transportCode', (carrierInfo) => {
      if (!carrierInfo.id) {
        return
      }

      this.visible = true
      getTransportCode(carrierInfo.id, carrierInfo.typeId).then(({ result }) => {
        this.codeSrc = result
      })
    })
  },
  beforeDestroy () {
    bus.$off('transportCode')
  }
}
</script>
